export default __webpack_public_path__ + "b2a27e63585ddb7a42f26bb1882bff08.png";